<template>
  <div class="flex">
    <DropdownModule
      class="flex"
      :width="280"
      append-to-body
      position-menu="left"
      button-classes="px-10 py-8 font-semibold"
      :background="isDarkMode ? 'bg-sidebar' : 'bg-white'"
    >
      <template #button="{isOpen}">
        <div class="group flex max-w-150 md:max-w-full cursor-pointer">
          <BookLabel
            :background="`${isDarkMode ? 'bg-error' : 'bg-grey-light group-hover:bg-grey-light-hover anim-color'}`"
            class="truncate py-4 font-semibold text-15"
            :book="currentBook"
            custom-classes="mr-8 text-13 w-29 h-29"
          />
          <i class="hidden md:block icon-keyboard-arrow-down text-12 self-center group-hover:opacity-100 text-app-color ml-8"
             :class="isOpen ? 'opacity-100' : 'opacity-0'"
          />
        </div>
      </template>

      <div class="rounded-10 text-14 text-app-color max-h-264 overflow-y-auto">
        <div
          v-for="b in allBooks"
          :key="b.id"
          class="first:rounded-t-10 last:rounded-b-10 hover:bg-selection group-scope flex items-center
                 justify-between cursor-pointer border-b last:border-0 p-7 pr-20"
          :class="isDarkMode ? 'border-project' : 'border-grey-500'"
          @click="changeBook(b)"
        >
          <BookLabel
            class="truncate px-12 py-4 font-medium"
            :book="b"
            :class="{'font-bold': book.id === b.id}"
            custom-classes="mr-13 text-14 w-30 h-30"
          />
          <i v-if="book.id === b.id" class="icon-check_mark text-18 self-center opacity-100 group-hover:opacity-100" />
        </div>
      </div>
    </DropdownModule>
  </div>
</template>

<script>
import DropdownModule from '@/components/shared/form-controls/DropdownModule'

import { defineComponent, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import BookLabel from '@/components/books/BookLabel'

export default defineComponent({
  components: { DropdownModule, BookLabel },

  setup () {
    const { state, getters, dispatch } = useStore()
    const route = useRoute()
    const router = useRouter()

    const team = computed(() => state.team.team)
    const book = computed(() => state.book.book || state.team.headquarters)
    const headquarters = computed(() => state.team.headquarters)

    const isDarkMode = computed(() => getters.isDarkMode)
    const isTeamAccount = computed(() => getters.isTeamAccount)

    const currentBook = computed(() => {
      const bookId = parseInt(route.params.id)

      return allBooks.value.find(i => i.id === bookId)
    })

    const allBooks = computed(() => {
      const books = state.book.books.filter(b => !b.isSection)

      if (isTeamAccount.value) {
        books.push(headquarters.value)
      }

      return books
    })

    const isToolPage = computed(() => ['TaskBoard', 'TaskBoardTeam', 'WeekPlanner', 'WeekPlannerTeam', 'Discussions', 'Discussion', 'Inbox'].includes(route.name))

    function changeBook (item) {
      const bookId = parseInt(route.params.id)

      if (bookId !== item.id) {
        if (isToolPage.value) {
          dispatch('getBook', item.id).then(res => {
            if (isTeamAccount.value && res.id && res.chat?.id) {
              dispatch('getMessages', {
                bookId: res.id,
                chatId: res.chat.id
              })
            }
          })
        }

        if (isTeamAccount.value && item.id === headquarters.value.id) {
          if (isToolPage.value) {
            router.replace({ params: { id: item.id }, query: route.query })
          } else {
            router.push({ name: 'Headquarters', params: { team: team.value.link, id: item.id } })
          }
        } else if (isTeamAccount.value && route.name === 'Headquarters') {
          router.push({ name: 'TeamBook', params: { team: team.value.link, id: item.id } })
        } else {
          router.replace({ params: { id: item.id }, query: route.query })
        }
      }
    }

    return {
      // computed
      team,
      book,
      allBooks,
      isDarkMode,
      currentBook,
      isTeamAccount,
      // functions
      changeBook
    }
  }
})
</script>
